import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const JsonViewerDialog = ({ open, onClose, jsonData }) => {
    const handleCopy = () => {
        navigator.clipboard.writeText(JSON.stringify(jsonData, null, 2));
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 2 }}>
                <Box display="flex" alignItems="center">
                    <IconButton onClick={handleCopy} size="small" sx={{ mr: 1 }}>
                        <ContentCopyIcon fontSize="small" />
                    </IconButton>
                    <Typography variant="h6" component="span">
                        JSON Data
                    </Typography>
                </Box>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {jsonData ? (
                    <Box
                        component="pre"
                        sx={{
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            fontFamily: 'Monospace',
                            fontSize: '0.9rem',
                            backgroundColor: '#f5f5f5',
                            borderRadius: 1,
                            p: 2
                        }}
                    >
                        {JSON.stringify(jsonData, null, 2)}
                    </Box>
                ) : (
                    <Typography>No data available</Typography>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default JsonViewerDialog;
